import styled from 'styled-components';

import { media } from '~/src/styles-constants';

export const QR_SIZE = 172;

const QR_SPACE = 64; // Padding du bloc "Scan"
const QR_MOVE_Y = -QR_SIZE / 2; // 50% vers le bas
const QR_MOVE_X = -(QR_SIZE / 3 + QR_SPACE); // 33% gauche + espace

const ARROW_MOVE_Y = 16; // Ajustement manuel
const ARROW_MOVE_X = QR_SIZE + QR_MOVE_X + 8; // Aligné avec le QR Code + ajustement manuel

export const Container = styled.section`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: column;

  ${media.M`
    flex-direction: row-reverse;
    justify-content: center;
    gap: 64px;
  `}
`;

export const Textual = styled.div`
  flex: 1 1 auto;

  p {
    margin: 0;
    padding: 0;

    strong {
      display: block;
      margin: 0;
      padding: 0 8px;
      font-size: 40px;
      font-weight: 700;
      line-height: 40px;
      text-wrap: balance;
      text-transform: uppercase;
      color: ${({ theme }) => theme.palette.common.TEXTS};
      font-family: ${({ theme }) => theme.fonts.quaternary};
    }

    span {
      display: block;
      margin: 0;
      padding: 12px 8px 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      white-space: pre-wrap;
      text-wrap: balance;
      color: ${({ theme }) => theme.palette.common.TEXTS};
      font-family: ${({ theme }) => theme.fonts.primary};
    }
  }

  footer {
    display: flex;
    padding: 24px 0 0;
    gap: 16px;

    a {
      flex: 1 1 1px;
      display: block;
      max-width: 225px;
    }

    svg {
      display: block;
      height: auto;
      width: 100%;
      aspect-ratio: 135/40;
    }
  }

  ${media.M`
    order: 1;
    p strong { font-size: 64px; line-height: 64px; }
    p span { font-size: 16px; line-height: 24px; }
    footer { gap: 24px }
  `}
`;

export const Visual = styled.div`
  flex: 0 0 auto;
  display: flex;

  > img {
    margin: 0 0 8px;
    max-width: 160px;
  }

  > div {
    display: none;
    padding: 48px ${QR_SPACE}px 0;

    > span {
      display: block;
      max-width: 180px;
      font-size: 32px;
      font-weight: 700;
      text-align: center;
      text-transform: uppercase;
      font-family: ${({ theme }) => theme.fonts.quaternary};
    }

    > svg {
      display: block;
      width: 112px;
      translate: ${ARROW_MOVE_X}px ${ARROW_MOVE_Y}px;
      fill: ${({ theme }) => theme.palette.common.PRIMARY};
    }

    > a {
      translate: ${QR_MOVE_X}px ${QR_MOVE_Y}px;
    }
  }

  ${media.S`> img { max-width: 240px; }`}
  ${media.L`> div { display: block; }`}
`;
